import { keyframes } from '@emotion/react';

export const spin = keyframes`
0% {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
100% {
  -webkit-transform: rotate(540deg);
  transform: rotate(540deg);
}
`;
